import { render, staticRenderFns } from "./SentenciasNewOrEdit.vue?vue&type=template&id=6c30b143&scoped=true&"
import script from "./SentenciasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./SentenciasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./SentenciasNewOrEdit.vue?vue&type=style&index=0&id=6c30b143&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30b143",
  null
  
)

export default component.exports